import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/compat/firestore';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { Companion } from '../models/companion';
import { Observable } from 'rxjs';
import { SnackBarIconService } from '../shared/snack-bar-icon/snack-bar-icon.service';

@Injectable({
  providedIn: 'root'
})
export class CompanionService {

  private itemDoc: AngularFirestoreDocument<Companion>;
  private item: Observable<Companion>;

  constructor(private db: AngularFirestore,
    private fs: AngularFireStorage,
    private ff: AngularFireFunctions,
    private snackBar: SnackBarIconService) { }

  select() {
        return this.db.collection<Companion>('sbccv_companions', ref => ref.orderBy('name', 'asc')).snapshotChanges();            
  }

  selectById(id) {
    this.itemDoc = this.db.doc<Companion>('sbccv_companions/' + id);
    this.item = this.itemDoc.valueChanges();
    return this.item;
  }

  selectByMember(member_id) {
    return this.db.collection<Companion>('sbccv_companions', ref => ref
    .where('member_id', '==', member_id)
    .orderBy('name', 'asc')).snapshotChanges();
  }

  insert(entity: Companion) {
    delete entity.id;
    return this.db.collection('sbccv_companions').add(Object.assign({}, entity));
  }

  update(entity: Companion) {
    let id = entity.id;
    delete entity.id;
    return this.db.collection('sbccv_companions').doc(id).set(Object.assign({}, entity));
  }

  delete(entity_id: any) {
    return this.db.collection('sbccv_companions ').doc(entity_id).delete();
  }

  makeMsgError(errorsCode) {
    let msgError: string
    switch (errorsCode) {
      case "auth/email-already-exists":
        msgError = "Este email já está em uso"
        break;
    }
    return msgError
  }

}


